import { useEffect, useState } from 'react'

import { ALLOW_DOMAIN_URL } from 'utils/post'

type HandlerUrlProps = {
  formatUrl: string
  isValidUrl: boolean
  isExternalUrl: boolean
  isExternalSite: boolean
  isInternalSite: boolean
  isCurrentSite: boolean
}

export function useHandlerUrls(linkTo: string[]) {
  const [linkData, setLinkData] = useState<HandlerUrlProps[]>([])

  useEffect(() => {
    const tmp: HandlerUrlProps[] = []
    linkTo.map((i) => {
      const fullUrl = i.startsWith('http')
        ? i
        : i.startsWith('#')
        ? `${window.location.origin}${window.location.pathname}${i}`
        : ''
      let isExternalUrl = false
      let isExternalSite = false
      try {
        const url = new URL(fullUrl)
        const isLocal = url.origin === window.location.origin
        isExternalSite = !(
          ALLOW_DOMAIN_URL.some((o) => url.origin.endsWith(o)) || isLocal
        )
        isExternalUrl =
          isExternalSite ||
          url.pathname.startsWith('/care/') ||
          url.pathname.startsWith('/community/')

        tmp.push({
          formatUrl: fullUrl,
          isExternalUrl,
          isExternalSite,
          isInternalSite: !isExternalSite,
          isCurrentSite:
            !isExternalSite && url.pathname === window.location.pathname,
          isValidUrl: i.startsWith('http') || i.startsWith('#'),
        })
      } catch (e) {
        tmp.push({
          formatUrl: '',
          isValidUrl: false,
          isExternalUrl: false,
          isExternalSite: false,
          isInternalSite: false,
          isCurrentSite: false,
        })
      }
    })

    setLinkData(tmp)
  }, [])
  return linkData
}
